import { isAdmin } from '@/policies/index';
import { PlanOptionCodes } from '@/types/company';
// 出面集計（会社全体のメンバー別の月次人日集計）に入れる人。出面オプションが有効な会社の管理者。
// バックエンドの AttendancePolicy#member_export?（会社の管理者）と、出面オプションの有効化に合わせる。
// サイドメニューの表示とページの middleware が、同じこの判定を参照する。
var attendanceSummary = {
    index: function (company) {
        var options = company.plan_options || [];
        return (isAdmin(company.user_type) &&
            options.some(function (option) { return option.code === PlanOptionCodes.Attendance; }));
    }
};
export default attendanceSummary;
